import { DATE_FORMAT } from "helpers/common";
import Badge from "react-bootstrap/Badge";
import React from "react";
import { Link } from "react-router-dom";

const STATUS = {
  active: "Active",
  inactive: "Inactive",
  deleted: "Deleted",
};

const Columns = ({ deleteHandler, handleEdit, viewHandler, handleStatus }) => [
  {
    dataField: "language_name",
    text: "Name",
    formatter: (_, row) => (
      <span className="text-capitalize">{row?.language_name}</span>
    ),
  },
  {
    dataField: "language_native_name",
    text: "Native Name",
    formatter: (_, row) => (
      <span className="text">{row?.language_native_name}</span>
    ),
  },
  {
    dataField: "locale_code",
    text: "Code",
    formatter: (_, row) => <span className="text">{row?.locale_code}</span>,
  },
  {
    dataField: "country_name",
    text: "Country",
    formatter: (_, row) => (
      <span className="text-capitalize">{row?.country_name}</span>
    ),
  },
  {
    dataField: "flag_url",
    text: "Flag",
    formatter: (_, row) => (
      <img
        src={row?.flag_url}
        className="main-sidebar-logo img-fluid fullIcn"
      />
    ),
  },
  {
    text: "Status",
    dataField: "status",
    formatter: (cellContent, row) => (
      <Badge
        className={`text-capitalize font-size-13 badge-soft-${row.status == "active" ? "Active" : "Inactive"}`}
        color={row.badgeClass}
      >
        {STATUS[row.status]}
      </Badge>
    ),
    // formatter: (_, row) => (
    //   <Badge bg="secondary">{row.status == "yes"? "Active" : "Inactive"}</Badge>
    // ),
  },
  {
    text: "Created At",
    dataField: "date_created_utc",
    formatter: (_, row) => DATE_FORMAT(row.date_created_utc),
  },
  {
    text: "Action",
    // dataField: "Inactive",
    formatter: (_, row) => (
      <>
        <button
          className="fas fa-pen"
          title="Edit"
          style={{
            backgroundColor: "#fff",
            border: "none",
          }}
          onClick={() => handleEdit(row)}
        ></button>
        {row.status == "active" ? (
          <button
            className="fas fa-toggle-on"
            style={{
              fontSize: "20px",
              color: "green",
              backgroundColor: "#fff",
              border: "none",
            }}
            title="Active"
            onClick={() => handleStatus(row._id, "inactive")}
          ></button>
        ) : (
          <button
            className="fas fa-toggle-off"
            style={{
              fontSize: "20px",
              color: "red",
              backgroundColor: "#fff",
              border: "none",
            }}
            title="Inactive"
            onClick={() => handleStatus(row._id, "active")}
          ></button>
        )}

        {
          <button
            className="fas fa-trash-alt"
            style={{
              backgroundColor: "#fff",
              border: "none",
            }}
            title="Delete"
            onClick={() => deleteHandler(row._id)}
          ></button>
        }

        <button
          className="fas fa-eye"
          style={{
            fontSize: "16px",
            backgroundColor: "#fff",
            border: "none",
          }}
          title="View JSON"
          onClick={() => viewHandler(row)}
        ></button>
      </>
    ),
  },
];
export default Columns;
